<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>마이페이지</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">마이페이지</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권 이용내역</p>
          <ul class="depth">
            <li><router-link to="/mypagemain" title="회원정보">회원정보</router-link></li>
            <li><router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link></li>
            <li><router-link to="/mypagediscountpayment" title="웹 선불권 이용내역">웹 선불권 이용내역</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">웹 선불권 충전내역</h3>
        <div id="tabs">
          <ul class="tabMenu type02">
            <li class="active">
              <router-link to="/mypagediscountpayment" title="웹 선불권 충전내역">웹 선불권 충전내역</router-link>
            </li>
            <li><router-link to="/mypagediscount" title="웹 선불권 사용내역">웹 선불권 사용내역</router-link></li>
          </ul>
          <section class="tabCont">
            <article class="amountArea">
              <div class="txt">
                나의 충전 시간은
                <div class="flex">
                  <div class="amount">{{ timeUserInfo.remainingTime | comma }}</div>
                  분 입니다.
                </div>
              </div>
            </article>
            <article class="selectOpt">
              <dl>
                <dt>결제기간</dt>
                <dd>
                  <date-picker :propsDate="searchDate"></date-picker>
                  <button type="button" class="btn dkGray" @click="search()">조회</button>
                </dd>
              </dl>
            </article>
            <article>
              <div class="scroll-table">
                <i class="v-scroll"></i>
                <div class="table vertical-table">
                  <table>
                    <caption>
                      웹 선불권 충전내역 테이블
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">순번</th>
                        <th scope="col">일시</th>
                        <th scope="col">구매 시간</th>
                        <th scope="col">구매금액</th>
                        <th scope="col">결제방법</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in listData" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.buyDttm }}</td>
                        <td>{{ item.buyTime }}분</td>
                        <td>{{ item.cardApprovalAmt | comma }}원</td>
                        <td v-if="item.payMethod === 'CARD'">카드</td>
                        <td v-else-if="item.payMethod === 'KAKAO'">카카오페이</td>
                        <td v-else-if="item.payMethod === 'PAYCO'">페이코페이</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>
          </section>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import moment from 'moment';

export default {
  data() {
    return {
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      listData: [],
      timeUserInfo: {},
      totalTime: 0,
      parkingInfo: [],
    };
  },

  components: {
    DatePicker,
  },

  mounted() {
    this.search();
    this.initView();
  },

  methods: {
    async initView() {
      const res = await axios('get', '/api/time/point', {
        portalId: this.$store.state.empNo,
        empEsntlId: this.$store.state.empEsntlId,
      });

      const data = res.data.result;
      const parkingData = res.data.mappingList;

      if (!data || data.length < 0) {
        this.timeUserInfo = {};
        return;
      } else {
        this.timeUserInfo = data.data;
        this.totalTime = data.data.remainingTime;
      }

      if (!parkingData || parkingData.length < 0) {
        this.parkingInfo = {};
        return;
      } else {
        this.parkingInfo = parkingData;
      }
    },
    async search() {
      let res = null;
      this.listData = [];
      let apiParams = new FormData();
      apiParams.append('startDt', this.searchDate.startDate.toString() + ' 00:00:00');
      apiParams.append('endDt', this.searchDate.endDate.toString() + ' 23:59:59');
      const sd = this.searchDate.startDate.toString() + ' 00:00:00';
      const ed = this.searchDate.endDate.toString() + ' 23:59:59';
      res = await axios('get', '/api/time/buy/list.json', {
        startDt: sd,
        endDt: ed,
      });
      const data = res.data;
      this.listData = data.result.list;
    },
  },
};
</script>
